import Address from "./Address";

export default class Marker {
    constructor(map, data) {
        this.map = map;

        for (let key in data) {
            switch (key) {
                case "address" :
                    this.address = new Address(data[key]);
                    break;
                default :
                    this[key] = data[key];
            }
        }
    }

    getId() {
        return this.id;
    }

    getOptions() {
        return {
            icon: this.getIcon(),
        }
    }

    getPosition() {
        return {
            lat: this.address.lat,
            lng: this.address.lng,
        }
    }

    getIcon() {
        let icon = null;

        switch (this.getLayer().handle) {
            case "locker" :
                if (this.map && this.map.$mapObject && this.map.$mapObject.zoom <= 13) {
                    icon = {
                        url: "/images/marker-dot.svg",
                        scaledSize: {width: 14, height: 14},
                    };
                } else {
                    icon = {
                        url: "/images/marker-locker.svg",
                        scaledSize: {width: 24, height: 42},
                    };
                }
                break;

            case "storefront" :
                icon = {
                    url: "/images/marker-pin.svg",
                    scaledSize: {width: 34, height: 48},
                };
                break;
        }

        return icon
    }

    getLayer() {
        return this.type;
    }

    getLayerId() {
        return this.getLayer().id;
    }
}
